import { onceInViewport } from '@js/util/helpers'
import { select } from '@js/util/select.js'

select('.wpce-testimonial', async testimonialElement => {
  if (testimonialElement.dataset.interactive !== 'true') return

  await onceInViewport(testimonialElement, { margin: '50%' })
  const { default: Swiper } = await import('swiper')

  const swiper = new Swiper(testimonialElement.querySelector('.swiper'), {
    direction: 'horizontal',
    loop: true,
    threshold: 30,
    centeredSlides: true,
    slidesPerView: 1,
    autoplay: false,
    autoHeight: true,
  })

  testimonialElement.querySelector('.custom-button-prev').addEventListener('click', () => {
    swiper.slidePrev()
  })

  testimonialElement.querySelector('.custom-button-next').addEventListener('click', () => {
    swiper.slideNext()
  })
})
